/*eslint-disable*/
import React, {useState, useEffect} from "react";
import {Link, useLocation} from "react-router-dom";

import APIClient from "../client";
import config from "../config.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import CardPredictionDashboard from "../components/Cards/CardPredictionDashboard.js";
import CardError from "../components/Cards/CardError.js";

import '../assets/styles/App.css';
import "@fontsource/montserrat";


const client = new APIClient(config);

export default function PredictionDashboard() {

    const [all, setAll] = useState({});
    const [partner, setPartner] = useState(null);
    const [funder, setFunder] = useState(null);
    const [country, setCountry] = useState(null);
    const [currency, setCurrency] = useState(null);

    const [predictionData, setPredictionData] = useState({});


    const [status, setStatus] = useState();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState();
    const [errorLink, setErrorLink] = useState('');
    const [errorDescription, setErrorDescription] = useState('');

    const {state} = useLocation();

    document.title = "Opportunity";

    useEffect(() => {
        setPartner(state[0]["partner"]);
        setFunder(state[0]["funder"]);
        setCountry(state[0]["country"]);
        setCurrency(state[0]["currency"]);

        Promise.all([
            client.getFunderBase(state[0]["partner"], state[0]["funder"]),
            client.getFunderForecast(state[0]["partner"], state[0]["funder"])
        ])
            .then(([resCurrent, resForecast]) =>
                Promise.all([resCurrent, resForecast])
            )
            .then(([dataCurrent, dataForecast]) => {
                if ([dataCurrent, dataForecast]) {
                    if (Object.keys(dataForecast['data']['data']).length > 0 && Object.keys(dataCurrent['data']['data']).length > 0) {
                        const keys = {"total_index": Object.keys(dataForecast['data']['data'])};

                        const predictionData = {...dataCurrent['data']['data'], ...dataForecast['data']['data'], ...state[0], ...keys};
                        setPredictionData(predictionData);

                        setStatus(200);
                        setLoading(false);
                    } else {
                        setStatus(500);
                        setMessage("Looks like there are currently no opportunities. ");
                        setErrorLink("/opportunities");
                        setErrorDescription("Click here to see available opportunities.");
                        setLoading(false);
                    }
                } else {
                    setStatus(500);
                    setMessage("Looks like we cant show this at the moment.");
                    setLoading(false);
                }
            })
            .catch(function (error) {
                console.log(error);
                setStatus(500);
                setMessage("Looks like we cant show this at the moment.");
                setLoading(false);

            })

    }, []);

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    <>

                        <h2 className="text-36 text-yellow mb-6">Investment Opportunity in {country}</h2>
                        <p className="text-20-30 text-white">
                            Match risk to desired disbursements and yield.
                        </p>

                        {loading && (
                            <div className="text-xl text-yellow font-medium">Loading...</div>
                        )}
                        {(status === 200) ?
                            (

                                <CardPredictionDashboard chartData={predictionData}/>

                            ) :
                            (
                                <CardError message={message} link={errorLink} description={errorDescription}/>
                            )
                        }

                        <div className="container mx-auto mt-b px-8">
                            <p className="text-white text-16-150 text-right">
                                <Link
                                    className="leading-relaxed underline inline-block mr-4 pr-10"
                                    to="/terms-of-use"
                                >Terms of Use
                                </Link></p>
                        </div>
                    </>
                </div>

            </section>
        </>
    );
}